<script setup lang="ts">
import { computed, defineEmits, defineProps, ref } from "vue";
import { useI18n } from "vue-i18n";
import TextInput from "@/components/inputs/TextInput.vue";
import LoaderIcon from "@/components/icons/LoaderIcon.vue";
import ConfirmButton from "@/views/Auth/components/ConfirmButton.vue";

defineProps<{
  waitApiCall: boolean;
}>();
const emits = defineEmits<{
  (e: "signup", email: string, password: string, passwordConfirm: string): void;
}>();

const { t } = useI18n();

const email = ref<string>("");
const password = ref<string>("");
const passwordConfirm = ref<string>("");

const isCredentialsValid = computed(() => {
  const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return (
    emailRe.test(email.value) &&
    password.value &&
    password.value.length > 0 &&
    password.value === passwordConfirm.value
  );
});

function handleSignUp() {
  if (!isCredentialsValid.value) {
    return;
  }
  emits("signup", email.value, password.value, passwordConfirm.value);
}
</script>

<template>
  <TextInput
    :label="t('auth.email')"
    v-model="email"
    type="email"
    class="mb-4"
  />
  <TextInput
    :label="t('auth.password')"
    v-model="password"
    type="password"
    class="mb-4"
  />
  <TextInput
    :label="t('auth.confirm-password')"
    v-model="passwordConfirm"
    type="password"
    class="mb-10"
  />
  <ConfirmButton
    :disabled="!isCredentialsValid || waitApiCall"
    :loading="waitApiCall"
    :button-text="t('auth.sign-up')"
    @click="handleSignUp"
  />
</template>
